<div>
  <div>
    <input type="checkbox"
           id="selectAll"
           [checked]="isAllSelected"
           (change)="toggleAllSelection($event)" />
    <label for="selectAll"><strong>Select All</strong></label>
  </div>
  <p-tree [value]="treeData"
          [(selection)]="selectedNodes"
          selectionMode="checkbox"
          [propagateSelectionDown]="true"
          [propagateSelectionUp]="true"
          [filter]="true"
          [style]="{ 'max-height': '400px', 'overflow': 'auto' }">
  </p-tree>

  <!-- Buttons -->
  <div class="button-container">
    <button type="button"
            class="btn buttonCancel"
            (click)="cancel()">
      <strong>{{ 'common.Cancel' | translate }}</strong>
    </button>
    <button type="button"
            class="btn buttonOk"
            (click)="save()">
      <strong>{{ 'common.Save' | translate }}</strong>
    </button>
  </div>
</div>

